import g from "glamorous";

const breakpoints = {
	lg: 1199,
	md: 991,
	sm: 767,
	xs: 576,
	xxs: 320
};

const generalStyles = {
	transition: "all 0.2s cubic-bezier(.4,0,.2,1)",
	Section: g.section(
		{
			position: "relative",
			clear: "both",
			marginTop: "12rem",
			[`@media (max-width: ${breakpoints.lg}px)`]: {
				marginTop: "4rem"
			},
			[`@media (max-width: ${breakpoints.md}px)`]: {
				marginTop: "6rem"
			},
			[`@media (max-width: ${breakpoints.sm}px)`]: {
				marginTop: "4rem"
			},
			":first-child": {
				marginTop: 0
			},
			":last-child": {
				marginBottom: "4rem",
				[`@media (max-width: ${breakpoints.md}px)`]: {
					marginBottom: "6rem"
				},
				[`@media (max-width: ${breakpoints.xs}px)`]: {
					marginBottom: "8rem"
				}
			}
		},
		props => {
			let styles = {};
			styles.minHeight = props.minHeight ? props.minHeight : "";
			styles.display = props.flex ? "flex" : "block";
			return styles;
		}
	),
	mediaQueries: {
		xxs: `@media (max-width: ${breakpoints.xxs}px)`,
		xs: `@media (max-width: ${breakpoints.xs}px)`,
		sm: `@media (max-width: ${breakpoints.sm}x)`,
		md: `@media (max-width: ${breakpoints.md}px)`,
		lg: `@media (max-width: ${breakpoints.lg}px)`
	},
	visibility: (breakpoint, visible = true, display = "block") => {
		let style = {
			[`@media (max-width: ${breakpoints[breakpoint]}px)`]: visible
				? {
						display: display
					}
				: {
						display: "none",
						visibility: "hidden"
					}
		};
		return style;
	},
	widthBreakpoint: () => {
		if (typeof window !== `undefined`) {
			let width = window.innerWidth;
			let breakpointRet = "";
			Object.keys(breakpoints).map(breakpoint => {
				if (width <= breakpoints[breakpoint]) {
					breakpointRet = breakpoint;
				}
			});
			return breakpointRet;
		}
	}
};

export default generalStyles;



// WEBPACK FOOTER //
// ./src/utils/generalStyles.js